
class WebshopListaSzuresStatic {

    constructor() {
        this.stopTopScrolling = true;
        this.searchTextTimer = null;
        this.searchTextAjaxStarted = false;
        this.ujlista = false;
        this.design2024 = false;
        this.showFrArak = false;
        this.arak2026 = false;
        this.timer = null;
        this.globalsCoolmetic = false;
    }

    init(aktKat) {

        // $('.webshop-termek-list-kont.static.v2 .kategchooser-kont').css({
        //     'position': 'relative',
        //     // 'top': 'auto',
        //     'bottom': 'auto'
        // }).removeClass('fixed-floated');

        let baseListroot = $('.webshop-termek-list-kont.static');
        let baseChooser = $('.kategchooser-kont', baseListroot);

        if ($('.webshop-termek-lista-kont-2024').length > 0) {
            baseListroot = $('.webshop-termek-lista-kont-2024');
            baseChooser = $('.kategchooser-kont', baseListroot);
        }

        $('.alkategoria-list', baseChooser).removeClass('opened');
        $('ul li a', baseChooser).removeClass('active');

        $('ul li > ul', baseChooser).each((i, ra) => {

            $(ra).find('li > a').each((indx, menuel) => {
                $(menuel).on('click', (e) => {
                    e.preventDefault();

                    var urlKat = $(e.target).attr('href');
                    var urlKatA = urlKat.split('&');
                    urlKatA = urlKatA.filter(function (item) {
                        return /alkat=\d+/.test(item);
                    });

                    var alkatid = 0;

                    if (urlKatA.length > 0) {
                        alkatid = urlKatA[0].replace('alkat=', '');
                    }

                    this.clickAlkategLink(alkatid);
                    this.updateItemsCounter();

                    urlKatA = [];
                    var akne = $(e.target).text().trim();
                    urlKatA.push('nev=' + General.makeAlias(akne) + '&alkat=' + alkatid);

                    urlKat = urlKatA.join('&');
                    if (urlKat[0] == "&") urlKat = urlKat.substr(1);

                    History.pushState(
                        { urlKat: urlKat, rand: Math.random() },
                        '',
                        "#" + urlKat
                    );

                    // $(this).parents('ul').find('a').removeClass('active');
                    // $(this).addClass('active');

                });
            });

            if (document.location.search.indexOf('kid=') > -1) {
                var katid = (new URLSearchParams(document.location.search).get('kid') || '').replace(/\/+$/, '');
                if (+katid > 0) {
                    if ($(ra).data('fokateg') == katid) {
                        $(ra).parent().find('> a').addClass('active');
                        $(ra).parent().find('> ul').addClass('opened');

                        var urlKat = (window.location.hash || History.getHash() || '').replace(/^#/, '');
                        var urlKatA = urlKat.split('&');
                        urlKatA = urlKatA.filter(function (item) {
                            return /alkat=\d+/.test(item);
                        });

                        var alkatid = "";
                        if (urlKatA.length > 0) {
                            alkatid = urlKatA[0].replace('alkat=', '');
                        }

                        if ("" + alkatid != "") {
                            this.clickAlkategLink(alkatid);
                        }
                    }
                }
            }
        });

        var urlKatGlobal = (window.location.hash || History.getHash() || '').replace(/^#/, '');
        var alkatMatch = urlKatGlobal.match(/alkat=(\d+)/);
        if (alkatMatch && alkatMatch[1]) {
            var alkatidGlobal = alkatMatch[1];
            var alkatLink = $('a', baseChooser).filter(function () {
                var href = $(this).attr('href') || '';
                var match = href.match(/[#&?]alkat=(\d+)/);
                return match && match[1] === String(alkatidGlobal);
            });
            if (alkatLink.length > 0) {
                alkatLink.closest('.alkategoria-list').addClass('opened');
                alkatLink.closest('.alkategoria-list').parent().find('> a').addClass('active');
            }
            this.clickAlkategLink(alkatidGlobal);
        }

        if (document.location.search.indexOf('kid=') > -1) {
            var katid = (new URLSearchParams(document.location.search).get('kid') || '').replace(/\/+$/, '');

            console.log('katid', katid);
            if ("" + katid != "") {
                $('form > ul > li > a', baseChooser).removeClass('active');
                $('form > ul > li > a', baseChooser).filter(function () {
                    var href = $(this).attr('href') || '';
                    var match = href.match(/[?&]kid=([^&#/]+)/);
                    return match && match[1] === String(katid);
                }).addClass('active a1');
            }
        } else {
            $('form > ul > li > a', baseChooser).removeClass('active');
            if (document.location.search.indexOf('products=') == -1) {
                $('form > ul > li > a:first', baseChooser).addClass('active a1');
            }
        }

        $('.filter-kont input:checkbox', baseListroot).on("click", function () {

            if (/\db/.test($(this).val())) {
                var parkatid = $(this).val().replace('b', '');
            }

        });

        $("input#akciosszures").on("click", (e) => {
            this.filterAkcioszures();
        });

        $("input#webshoplista_csakbio_filter").on("click", (e) => {
            this.filterBioszures();
        });

        if (History.getHash() != "") {
            var urlKat = History.getHash();

            if (urlKat.indexOf('filter=sale') > -1) {
                $("input#akciosszures").trigger('click');
            }
            if (urlKat.indexOf('filter=bio') > -1) {
                $("input#webshoplista_csakbio_filter").trigger('click');
            }
        }

        $('.kategchooser-kont select', baseListroot).empty();

        var aktSelVal = document.location.pathname + document.location.search;

        $('.webshop-termek-list-kont.v3 .kategchooser-kont ul li a').each(function (i, ak) {

            var opt = $('<option>')
                .val($(ak).attr("href"))
                .text($(ak).text().toUpperCase().trim());

            if (opt.val() == aktSelVal) {
                opt.attr("selected", "selected");
            }
            opt.appendTo($('.webshop-termek-list-kont.static .kategchooser-kont select'));

            if (opt.val() == aktSelVal) {
                $('.webshop-termek-list-kont.static .kategchooser-kont select').val(aktSelVal);
            }
        });

        $('.kategchooser-kont select', baseListroot).on("change", function () {

            document.location.href = $(this).val();

        });


        // 2024
        $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel').empty();
        let processed = [];
        let aktSelValUrl = document.location.href.replace(document.location.origin, '');

        $('.webshop-termek-lista-kont-2024 .webshoplista-kont .kategchooser-kont ul:not(.alkategoria-list) li a').each((i, akai) => {

            if (processed.indexOf($(akai).attr('href')) > -1) {
                return;
            }
            if ($(akai).parent().find('ul').length > 0) {
                $(akai).parent().find('ul li a').each((i, ak) => {
                    this.buildKategMenuItem(ak, aktSelValUrl);
                    processed.push($(ak).attr('href'));
                });
            } else {
                this.buildKategMenuItem(akai, aktSelValUrl);
                processed.push($(akai).attr('href'));
            }
        });

        if ($('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-display a').attr('href') == '') {
            let firstLink = $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel a').first();
            $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-display a')
                .text(firstLink.text())
                .addClass(firstLink.data('menu-icon-class'))
                .attr('href', firstLink.attr('href'));
        }

        $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-display a').on("click", (e) => {
            e.preventDefault();
            if ($('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-wrapper').hasClass('active')) {
                $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-wrapper').removeClass('active');
            } else {
                $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-wrapper').addClass('active');
            }
        });

        $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-wrapper .button-close').on("click", (e) => {
            e.preventDefault();
            $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-wrapper').removeClass('active');
        });

        if (aktKat == '-2') {
            $('.productlist-kont .szures-kont label', baseListroot).addClass('hide');
            $('.productlist-kont .szures-kont .chkbox-kont', baseListroot).addClass('hide');
        } else {
            $('.productlist-kont .szures-kont label', baseListroot).removeClass('hide');
            $('.productlist-kont .szures-kont .chkbox-kont', baseListroot).removeClass('hide');
        }

        $('.hide-termekek2').addClass('hide');

        if ($('.fuszer-tipus-filter-kont').length > 0) {
            this.filterFuszertipusszures();
        }

        this.updateItemsCounter();

        // ha van alapértelmezett kiszerelés, az legyen az aktív a terméklistában
        $('.webshop-termek-lista-kont-2024 .termeklista2024-item .kiszerelesek-kont').each(function () {
            if ($(this).find('> a[data-kiszereles_alapertelmezett="1"]').length > 0) {
                $(this).find('> a[data-kiszereles_alapertelmezett="1"]:first').trigger('click');
            }
        });

        setTimeout(() => {
            this.stopTopScrolling = false;
        }, 2000);

    }

    buildKategMenuItem(ak, aktSelVal) {
        let kateglinkel = $('<a>')
            .attr('href', $(ak).attr("href"))
            .addClass('icon-' + $(ak).data('menu-icon-class'))
            .data('menu-icon-class', $(ak).data('menu-icon-class'))
            .text($(ak).text().trim());

        kateglinkel.appendTo($('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel'));

        if (kateglinkel.attr('href') == aktSelVal) {
            $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-display a')
                .text(kateglinkel.text())
                .addClass(kateglinkel.data('menu-icon-class'))
                .attr('href', kateglinkel.attr('href'));

        }
    }

    clickAlkategLink(alkatid) {

        let baseListroot = $('.webshop-termek-list-kont.static');

        if ($('.webshop-termek-lista-kont-2024').length > 0) {
            baseListroot = $('.webshop-termek-lista-kont-2024');
        }

        if (+alkatid > 0 && $('.keresomezo-kont input').val() == "") {
            $('.productlist-kont .item', baseListroot).addClass('hide');

            $('.productlist-kont', baseListroot)
                .find('.item[data-fokategoria=' + alkatid + ']:not(.akciohide):not(.biohide), .item[data-alkategoria=' + alkatid + ']:not(.akciohide):not(.biohide)')
                .removeClass('hide');

            $('.productlist-kont', baseListroot)
                .find('.item[data-fokategoria=' + alkatid + 'b]:not(.akciohide):not(.biohide), .item[data-alkategoria=' + alkatid + 'b]:not(.akciohide):not(.biohide)')
                .removeClass('hide');

            $('.kategchooser-kont form ul li > ul a', baseListroot).removeClass('active');
            $('.kategchooser-kont form ul li > ul a', baseListroot).filter(function () {
                var href = $(this).attr('href') || '';
                var match = href.match(/[#&?]alkat=(\d+)/);
                return match && match[1] === String(alkatid);
            }).addClass('active a2');

        } else {
            $('.productlist-kont .item:not(.akciohide):not(.biohide)', baseListroot).removeClass('hide');
        }

        if ($('.folderbykateg-items').length > 0) {
            $('.folderbykateg-items').find('.kategleadhtml-kont').addClass('hide');

            var topleadhtml = $('.folderbykateg-items').find('.kategleadhtml-kont#kateg' + alkatid);

            if ($(topleadhtml).length > 0 && $(topleadhtml).text().trim().length > 0) {
            } else {
                var topleadhtml = $('.folderbykateg-items').find('.kategleadhtml-kont#kateg-2');

                // $('.hide-termekek2').removeClass('hide');
                // $('.webshop-termek-list-kont:not(.static)').removeClass('topleadhtml-view');
            }
            $(topleadhtml).removeClass('hide');
            $('.webshop-termek-list-kont.static').addClass('topleadhtml-view');
        }
    }

    filterAkcioszures() {

        var urlKat = History.getHash();
        var urlKatA = urlKat.split('&');

        var allElements = $('.podor-productlist .item');

        if (allElements.length > 0) {

            allElements.each(function (i, el) {

                if ($("input#akciosszures").is(":checked")) {
                    if ($(el).find('.akcio-aktiv:not(.alap-kedvezmeny):not(.hide)').length == 0) {
                        $(el).addClass('hide akciohide');
                    }

                    if (urlKatA.indexOf('filter=sale') == -1) {
                        urlKatA.push('filter=sale');
                    }

                } else {
                    if ($(el).hasClass('akciohide')) {
                        $(el).removeClass('hide akciohide');
                    }

                    if (urlKatA.indexOf('filter=sale') > -1) {
                        urlKatA.splice(urlKatA.indexOf('filter=sale'), 1);
                    }
                }
            });
        } else {
            if ($(el).hasClass('akciohide')) {
                $(el).removeClass('hide akciohide');
            }
        }


        this.updateItemsCounter();

        urlKat = urlKatA.join('&');
        if (urlKat[0] == "&") urlKat = urlKat.substr(1);

        History.pushState(
            { urlKat: urlKat, rand: Math.random() },
            '',
            "#" + urlKat
        );
    }

    filterBioszures() {

        var urlKat = History.getHash();
        var urlKatA = urlKat.split('&');

        var allElements = $('.podor-productlist .item');

        if (allElements.length > 0) {

            allElements.each(function (i, el) {

                if ($("input#webshoplista_csakbio_filter").is(":checked")) {
                    if (+$(el).data('biotermek') != 1) {
                        $(el).addClass('hide biohide');
                    }

                    if (urlKatA.indexOf('filter=bio') == -1) {
                        urlKatA.push('filter=bio');
                    }

                } else {
                    if ($(el).hasClass('biohide')) {
                        $(el).removeClass('hide biohide');
                    }

                    if (urlKatA.indexOf('filter=bio') > -1) {
                        urlKatA.splice(urlKatA.indexOf('filter=bio'), 1);
                    }
                }
            });
        } else {
            if ($(el).hasClass('biohide')) {
                $(el).removeClass('hide biohide');
            }
        }


        this.updateItemsCounter();

        urlKat = urlKatA.join('&');
        if (urlKat[0] == "&") urlKat = urlKat.substr(1);

        History.pushState(
            { urlKat: urlKat, rand: Math.random() },
            '',
            "#" + urlKat
        );
    }

    filterFuszertipusszures() {

        var urlKat = History.getHash();
        var urlKatA = urlKat.split('&');


        $('.fuszer-tipus-filter-kont input').on('change', () => {

            if ($('.fuszer-tipus-filter-kont input:checked').length > 0) {

                $('.podor-productlist .item[data-fuszer_tipus]').addClass('hide');

                $('.fuszer-tipus-filter-kont input').each((i, el) => {
                    if ($(el).is(":checked")) {
                        let fuid = $(el).val();
                        $('.podor-productlist .item[data-fuszer_tipus="' + fuid + '"]').removeClass('hide');
                    }
                });


            } else {
                $('.podor-productlist .item[data-fuszer_tipus]').removeClass('hide');
            }
            this.updateItemsCounter();
        });


        urlKat = urlKatA.join('&');
        if (urlKat[0] == "&") urlKat = urlKat.substr(1);

        History.pushState(
            { urlKat: urlKat, rand: Math.random() },
            '',
            "#" + urlKat
        );
    }

    updateItemsCounter() {
        $(".productlist-kont .counter-kont span").text(+$('.podor-productlist .item:not(.hide)').length);
    }

    callAlkategoriaClick(alel) {
        /*
        var activeChecked = [];
        $(this).parents('ul').find(':checkbox:checked').each(function(){
            if (/b$/.test($(this).attr('id')))
            {
                activeChecked.push($(this).val()+'b');
            } else {
                activeChecked.push($(this).val());
            }
        });

        if (activeChecked.length == 0)
        {
            e.preventDefault();
            return false;
        }

        $('.webshop-termek-list-kont.static .productlist-kont .item').addClass('hide');
        for (var ind in activeChecked)
        {
            if (activeChecked.hasOwnProperty(ind))
            {
                $('.webshop-termek-list-kont.static .productlist-kont')
                    .find('.item[data-fokategoria='+activeChecked[ind]+'], [data-alkategoria='+activeChecked[ind]+']')
                    .removeClass('hide');
            }
        }
        */

        $("input#akciosszures").removeAttr("checked");

        var activeChecked = "";
        if (/b$/.test($(alel).attr('id'))) {
            activeChecked = $(alel).val() + 'b';
        } else {
            activeChecked = $(alel).val();
        }

        var foka = $(alel).parents('ul').data('fokateg');

        if (typeof activeChecked == 'undefined') {
            activeChecked = foka;
        }

        if ($('.folderbykateg-items').length > 0) {
            $('.folderbykateg-items').find('.kategleadhtml-kont').addClass('hide');

            if (activeChecked != 0) {
                var topleadhtml = $('.folderbykateg-items').find('.kategleadhtml-kont#kateg' + activeChecked);
            } else {
                var topleadhtml = $('.folderbykateg-items').find('.kategleadhtml-kont#kateg' + foka);
            }

            // console.log($(topleadhtml).text().trim().length)
            if ($(topleadhtml).length > 0 && $(topleadhtml).text().trim().length > 0) {
                $('.hide-termekek2').addClass('hide');
                $('.webshop-termek-list-kont.static').addClass('topleadhtml-view');
                $(topleadhtml).removeClass('hide');
            } else {
                var topleadhtml = $('.folderbykateg-items').find('.kategleadhtml-kont#kateg-2');
                $('.hide-termekek2').addClass('hide');
                $('.webshop-termek-list-kont.static').addClass('topleadhtml-view');
                $(topleadhtml).removeClass('hide');

                // $('.hide-termekek2').removeClass('hide');
                // $('.webshop-termek-list-kont.static').removeClass('topleadhtml-view');
            }
        }

        if (typeof foka == 'undefined') {
            History.pushState(
                { kateg: activeChecked, rand: Math.random() },
                '',
                "#k=" + activeChecked
            );
        } else {
            History.pushState(
                { kateg: activeChecked, rand: Math.random() },
                '',
                "#k=" + foka + '-' + activeChecked
            );

        }

        if (activeChecked == 0) {
            $('.webshop-termek-list-kont.static .productlist-kont .item').removeClass('hide');
        } else {
            $('.webshop-termek-list-kont.static .productlist-kont .item').addClass('hide');

            $('.webshop-termek-list-kont.static .productlist-kont')
                .find('.item[data-fokategoria=' + activeChecked + '], [data-alkategoria=' + activeChecked + ']')
                .removeClass('hide');
        }

        this.updateItemsCounter();
    }

    getList(kategoria, kategoria_kezi_id, termekadatlapkereso, extra) {

        if (!termekadatlapkereso) {
            var termekadatlapkereso = false;
        }

        if (!extra) {
            var extra = false;
        }

        if ($('.webshop-termek-list-kont.static .webshop-filter-result .podor-productlist').length > 0) {
            $('.webshop-termek-list-kont.static .webshop-filter-result .podor-productlist').empty();
            $('<div>').addClass('wait-datas').appendTo($('.webshop-termek-list-kont.static .webshop-filter-result .podor-productlist'));
        } else if ($('.webshop-termek-lista-kont-2024 .webshoplista-kont .webshop-filter-result').length > 0) {
            $('.webshop-termek-lista-kont-2024 .webshoplista-kont .webshop-filter-result').empty();
            $('<div>').addClass('wait-datas').appendTo($('.webshop-termek-lista-kont-2024 .webshoplista-kont .webshop-filter-result'));
        } else {
            $('.webshop-termek-list-kont.static .webshop-filter-result').empty();
            $('<div>').addClass('wait-datas').appendTo($('.webshop-termek-list-kont.static .webshop-filter-result'));
        }

        var sendData = { kategoria: kategoria };

        if (/\db/.test(kategoria)) {
            kategoria = kategoria.replace('b', '');
            sendData["biofilter"] = 1;
        }


        if (extra) {
            sendData["extra"] = extra;
        }

        if (termekadatlapkereso) {
            sendData["termekadatlapkereso"] = 1;
            sendData["ujlista"] = 1;
        } else {
            // if ($('.filter-switch').data('state') == 'on')
            if ($('.webshop-termek-list-kont.static .kategchooser-kont input#kategid_' + kategoria_kezi_id + 'b').is(':checked')) {
                sendData["biofilter"] = 1;
            }

            if (this.ujlista) {
                sendData["ujlista"] = 1;
            }
        }

        sendData["t"] = new Date().getTime();

        if (this.globalsCoolmetic) {
            sendData["globals_coolmetic"] = 1;
        }

        if (this.showFrArak) {
            sendData["showFrArak"] = 1;
        }

        if (this.arak2026) {
            sendData["arak2026"] = 1;
        }

        if (window.keresoCSRFToken !== undefined) {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-Token': window.keresoCSRFToken
                }
            });
        }

        this.searchTextAjaxStarted = true;
        $.get('/index.php/webshoplist_static/gethtml', sendData, (ret) => {
            this.searchTextAjaxStarted = false;

            if (termekadatlapkereso) {
                $('.termekkereso-talalatok').html(ret.html);

                Kosar.updateFirmenArlabel();
                termeklistaVideoFelugro.init();

                $('.podor-productlist .item').each(function () {

                    var that = this;
                    $(this).find('.akcio-aktiv, .bio').on("click", function () {
                        var pali = $(this).parents('.podor-product').find('a:not(.video-popup-link)').first();
                        document.location.href = pali.attr("href");
                    });

                    $('.clickable', $(this)).each(function () {
                        if ($(this).data('url') != "") {
                            $(this).on("click", function () {
                                document.location.href = $(this).data('url');
                            });
                        }
                    });


                    if ($(this).find('.title').text().length > 55) {
                        $(this).addClass("long-title");
                    }

                    $(this).find('a.image-wrapper').on('click touch', function () {
                        GTMDataPusher.listItemClick(that);
                        GtagDataPusher.listItemClick(that);
                    });
                });

            } else {
                if ($('.webshop-termek-lista-kont-2024 .webshop-filter-result').length > 0) {
                    $('.webshop-termek-lista-kont-2024 .webshop-filter-result').html(ret.html);
                } else {
                    $('.webshop-termek-list-kont.static .webshop-filter-result').html(ret.html);
                }
                Kosar.updateFirmenArlabel();
                termeklistaVideoFelugro.init();

                $('.podor-productlist .item').each(function () {

                    var that = this;
                    $(this).find('.akcio-aktiv, .bio').on("click", function () {
                        var pali = $(this).parents('.podor-product').find('a:not(.video-popup-link)').first();
                        document.location.href = pali.attr("href");
                    });

                    if ($(this).find('.title').text().length > 55) {
                        $(this).addClass("long-title");
                    }


                    $('.clickable', $(this)).each(function () {
                        if ($(this).data('url') != "") {
                            $(this).on("click", function () {
                                document.location.href = $(this).data('url');
                            });
                        }
                    });

                    var aktivKiszerelesekBase = $(this).find('.kiszereles-selectors .kiszerelesek-kont');
                    if ($('a[data-kiszereles_alapertelmezett="1"]', aktivKiszerelesekBase).length > 0) {
                        $('a[data-kiszereles_alapertelmezett="1"]:first', aktivKiszerelesekBase).trigger('click');
                    } else {
                        $('a:first', aktivKiszerelesekBase).trigger('click');
                    }


                    $(this).find('a.image-wrapper').on('click touch', function () {
                        GTMDataPusher.listItemClick(that);
                        GtagDataPusher.listItemClick(that);
                    });
                });

                this.updateItemsCounter();
                //this.filterAkcioszures();

                this.init(ret.kategoria);

            }



            popupSzettLista.init();

        }, 'json');

        return false;
    }

    textFilterInput(el, nowait) {
        if (!nowait) {
            var nowait = false;
        }

        if ($(el).val().length > 1) {

            if (this.timer) {
                clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
                this.textFilter($(el).val());
            }, 1000);


        } else {

            let baseListroot = $('.webshop-termek-list-kont.static');
            let extra = '';
            if ($('.webshop-termek-lista-kont-2024').length > 0) {
                baseListroot = $('.webshop-termek-lista-kont-2024');
                extra = 'onlyitems|termekajanlo2024|vasarlas|termeklista2024';
            }
            var aktkat = $(baseListroot).data('aktkat');
            var kategoria_kezi_id = $(baseListroot).data('kategoria_kezi_id');

            if (this.timer) {
                clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
                $('.folderbykateg-items').find('.kategleadhtml-kont#kateg' + kategoria_kezi_id).removeClass('hide');
                $('.filter-text-clear').addClass('hide');

                this.getList(aktkat, kategoria_kezi_id, false, extra);
            }, 1000);

        }

        return false;
    }

    textFilterClear() {
        let baseListroot = $('.webshop-termek-list-kont.static');
        $('.termeklista-felso-kereso-kont .keresomezo-kont input', baseListroot).val('');

        window.location.reload();

        return false;
    }

    textFilter(text) {

        if (this.searchTextAjaxStarted) {
            while (!this.searchTextAjaxStarted) {

            }
        }

        var sendData = { text: text };


        let baseListroot = $('.webshop-termek-list-kont.static');
        if ($('.webshop-termek-lista-kont-2024').length > 0) {
            baseListroot = $('.webshop-termek-lista-kont-2024');
            sendData["extra"] = 'onlyitems|termekajanlo2024|vasarlas|termeklista2024';
        }

        if ($('.webshop-filter-result .podor-productlist', baseListroot).length > 0) {
            $('.webshop-filter-result .podor-productlist', baseListroot).empty();
            $('<div>').addClass('wait-datas').appendTo($('.webshop-filter-result .podor-productlist', baseListroot));
        } else {
            $('.webshop-filter-result', baseListroot).empty();
            $('<div>').addClass('wait-datas').appendTo($('.webshop-filter-result', baseListroot));
        }


        // if ($('.filter-switch').data('state') == 'on')
        if ($('.row.termekekmenu-kont .filter-kont #termekmenu_csakbio_filter').is(':checked')) {
            sendData["biofilter"] = 1;
        }

        if (this.ujlista) {
            sendData["ujlista"] = 1;
        }

        if (this.globalsCoolmetic) {
            sendData["globals_coolmetic"] = 1;
        }


        if (window.keresoCSRFToken !== undefined) {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-Token': window.keresoCSRFToken
                }
            });
        }

        sendData["t"] = new Date().getTime();

        this.searchTextAjaxStarted = true;
        $('.folderbykateg-items').find('.kategleadhtml-kont:not(.hide)').addClass('hide');
        $.get('/index.php/webshoplist_static/gethtml', sendData, (ret) => {

            let baseListroot = $('.webshop-termek-list-kont.static');
            if ($('.webshop-termek-lista-kont-2024').length > 0) {
                baseListroot = $('.webshop-termek-lista-kont-2024');
            }

            $('.webshop-filter-result', baseListroot).html(ret.html);
            $("html, body").stop().animate({ scrollTop: $(baseListroot).offset().top - 30 }, '300');

            Kosar.updateFirmenArlabel();

            $('.podor-productlist .item').each((ind, ite) => {

                $(ite).find('.akcio-aktiv, .bio').on("click", (e) => {
                    var pali = $(e.target).parents('.podor-product').find('a:not(.video-popup-link)').first();
                    document.location.href = pali.attr("href");
                });

                $('.clickable', $(ite)).each(function () {
                    if ($(this).data('url') != "") {
                        $(this).on("click", function () {
                            document.location.href = $(this).data('url');
                        });
                    }
                });

                if ($(ite).find('.title').text().length > 55) {
                    $(ite).addClass("long-title");
                }

                this.searchTextAjaxStarted = false;
                $('.filter-text-clear').removeClass('hide');

                $(ite).find('a.image-wrapper').on('click touch', (e) => {
                    GTMDataPusher.listItemClick(ite);
                });



            });

            this.updateItemsCounter();
            //this.filterAkcioszures();

            this.init(ret.kategoria);




        }, 'json');

        return false;
    }

    textFilterInputTermekadatlap(el, nowait) {
        if (!nowait) {
            var nowait = false;
        }

        if ($(el).val().length > 1) {

            if (this.timer) {
                clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
                this.textFilterTermekadatlap($(el).val());
            }, 1000);


        } else {

            $('.termekkereso-talalatok-keret').addClass('hide');
            $('.termekkereso-talalatok').addClass('hide');
            $('.termekkereso-talalatok').empty();
            $('.termekkereso-talalatok-keret .lapozo-nyilak').addClass('hide');

            $('.cart-ujadatlap .cart-select-box .adatlap-kereso-kont .balranyil').addClass('hide');
            $('.main-content.ujadatlap .multipicselector-kont .mainpicture-kont .imgkont').removeClass('hide');
            var fadedItems = $('.cart-ujadatlap .cart-select-box form .kereso-overlayable');
            fadedItems.removeClass('faded').find('.overlay').remove();

        }

        return false;
    }

    textFilterInputTermekadatlapCloseResults() {

        $('.termekkereso-talalatok-keret').addClass('hide');
        $('.termekkereso-talalatok').addClass('hide');
        $('.cart-ujadatlap .cart-select-box .adatlap-kereso-kont .balranyil').addClass('hide');
        $('input#termekkereso').val('');

        $('.termekkereso-talalatok').empty();
        $('.termekkereso-talalatok-keret .lapozo-nyilak').addClass('hide');

        var fadedItems = $('.cart-ujadatlap .cart-select-box form .kereso-overlayable');
        fadedItems.removeClass('faded').find('.overlay').remove();

        $('.main-content.ujadatlap .multipicselector-kont .mainpicture-kont .imgkont').removeClass('hide');
        return false;
    }

    textFilterInputTermekadatlapResultsMoveLeft() {
        var baseRow = $('.termekkereso-talalatok-keret .termekkereso-talalatok .podor-productlist'),
            baseWidth = 255,
            maxOffset = (baseRow.find('.item').length - 1) * baseWidth,
            aktpage = baseRow.data('pagepoz'),
            newAktpage = aktpage - 1,
            newLeft = newAktpage * (3 * baseWidth);


        if (aktpage > 0 && newLeft <= maxOffset) {
            baseRow.css('left', (0 - newLeft) + 'px');
            baseRow.data('pagepoz', newAktpage);
        }

        if ((newLeft - baseWidth) < 0) {
            $('.termekkereso-talalatok-keret .lapozo-nyilak.left').addClass('hide');
        } else {
            $('.termekkereso-talalatok-keret .lapozo-nyilak.left').removeClass('hide');
        }

        if ((newLeft + (3 * baseWidth)) > maxOffset) {
            $('.termekkereso-talalatok-keret .lapozo-nyilak.right').addClass('hide');
        } else {
            $('.termekkereso-talalatok-keret .lapozo-nyilak.right').removeClass('hide');
        }

        return false;
    }

    textFilterInputTermekadatlapResultsMoveRight() {
        var baseRow = $('.termekkereso-talalatok-keret .termekkereso-talalatok .podor-productlist'),
            baseWidth = 255,
            maxOffset = (baseRow.find('.item').length - 1) * baseWidth,
            aktpage = typeof baseRow.data('pagepoz') == "undefined" ? 0 : baseRow.data('pagepoz'),
            newAktpage = aktpage + 1,
            newLeft = newAktpage * (3 * baseWidth);


        if (newLeft <= maxOffset) {
            baseRow.css('left', (0 - newLeft) + 'px');
            baseRow.data('pagepoz', newAktpage);
        }

        if (newLeft > 0) {
            $('.termekkereso-talalatok-keret .lapozo-nyilak.left').removeClass('hide');
        }

        if ((newLeft + (3 * baseWidth)) > maxOffset) {
            $('.termekkereso-talalatok-keret .lapozo-nyilak.right').addClass('hide');
        } else {
            $('.termekkereso-talalatok-keret .lapozo-nyilak.right').removeClass('hide');
        }

        return false;
    }

    textFilterTermekadatlap(text) {

        if (this.searchTextAjaxStarted) {
            while (!this.searchTextAjaxStarted) {

            }
        }

        if ($('.termekkereso-talalatok .podor-productlist').length > 0) {
            $('.termekkereso-talalatok .podor-productlist').empty();
            $('<div>').addClass('wait-datas').appendTo($('.termekkereso-talalatok .podor-productlist'));
        } else {
            $('.termekkereso-talalatok').empty();
            $('<div>').addClass('wait-datas').appendTo($('.termekkereso-talalatok'));
        }

        $('.termekkereso-talalatok').removeClass('hide');
        $('.termekkereso-talalatok-keret').removeClass('hide');
        $('.main-content.ujadatlap .multipicselector-kont .mainpicture-kont .imgkont').addClass('hide');
        $('.ujadatlap-tabok-kont').addClass('hide');


        $('.cart-ujadatlap .cart-select-box .adatlap-kereso-kont .balranyil').removeClass('hide');
        var fadedItems = $('.cart-ujadatlap .cart-select-box form .kereso-overlayable');
        fadedItems.addClass('faded');
        $('<div>').addClass('overlay').appendTo(fadedItems);

        var sendData = { text: text };

        // if ($('.filter-switch').data('state') == 'on')
        if ($('.row.termekekmenu-kont .filter-kont #termekmenu_csakbio_filter').is(':checked')) {
            sendData["biofilter"] = 1;
        }

        sendData["ujlista"] = 1;

        sendData["termekadatlapkereso"] = 1;

        sendData["t"] = new Date().getTime();

        if (window.keresoCSRFToken !== undefined) {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-Token': window.keresoCSRFToken
                }
            });
        }

        this.searchTextAjaxStarted = true;
        $.get('/index.php/webshoplist_static/gethtml', sendData, (ret) => {
            $('.termekkereso-talalatok').html(ret.html);
            Kosar.updateFirmenArlabel();

            $('.termekkereso-talalatok-keret .lapozo-nyilak').addClass('hide');

            if ($('.podor-productlist .item').length > 3) {
                $('.termekkereso-talalatok-keret .lapozo-nyilak.right').removeClass('hide');
            }

            $('.podor-productlist .item').each((ind, ite) => {

                $(ite).find('.akcio-aktiv, .bio').on("click", (e) => {
                    var pali = $(e.target).parents('.podor-product').find('a:not(.video-popup-link)').first();
                    document.location.href = pali.attr("href");
                });

                $('.clickable', $(ite)).each(function () {
                    if ($(this).data('url') != "") {
                        $(this).on("click", function () {
                            document.location.href = $(this).data('url');
                        });
                    }
                });

                if ($(ite).find('.title').text().length > 55) {
                    $(ite).addClass("long-title");
                }

                this.searchTextAjaxStarted = false;
                $('.filter-text-clear').removeClass('hide');

                $(ite).find('a.image-wrapper').on('click touch', (e) => {
                    GTMDataPusher.listItemClick(ite);
                });



            });

        }, 'json');

        return false;
    }

}

export default WebshopListaSzuresStatic;
